import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Container = styled.div`
`;

export const TextBoxContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  margin: 14px 0px 0px 0px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  align-items:center
`;

export const TextBoxInput = styled.input`
  width: 100%;
  height: 35px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #204078;
  margin: 0px 6px 0px 6px;
  border: none;
  outline: none;
`;

export const IconContainer = styled.div`
  margin: 0px 6px 0px 0px;
`;


